(function ($) {
    $(document).ready(function () {

        $('.header .menu-main').flexMenu({
            showOnHover: true,
            threshold: 2,
            cutoff: 2,
            linkText: "Еще...",
            linkTitle: "Показать еще",
            linkTextAll: "Меню",
            linkTitleAll: "Развернуть меню",
            popupClass: 'menu__dropdown'
        });

        // форма
        $("body").off("click");
        $("body").on("click", ".header-call-us__link",  function () {
            var headerWebform = $(this).next();
            if (headerWebform.css("display") === "none") {
                headerWebform.show();
            } else {
                headerWebform.hide();
            }
        });
        // end: форма

    });

    // форма
    $(document).click(function (event) {
        if ($(event.target).closest(".header-call-us__webform, .header-call-us__link").length) return;
        $(".header-call-us__webform").hide();
        event.stopPropagation();
    });
    // end: форма

})(jQuery);
